import React from 'react';
import db from './db.json';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { createGlobalStyle, ThemeProvider } from 'styled-components';

import HomePage from './pages/HomePage';
import Login from './pages/Login/Login';
import RecoverPassword from './pages/Login/RecoverPassword';
import ConfirmedEmail from './pages/Login/ConfirmedEmail';
import CompanyReg from './pages/Company/CompanyReg';
import CompanyEdit from './pages/Company/CompanyEdit';
import CompanyUserList from './pages/Company/CompanyUserList';
import UserReg from './pages/User/UserReg';
import UserEdit from './pages/User/UserEdit';
import UserEditAdmin from './pages/User/UserEditAdmin';
import UserList from './pages/User/UserList';
import SincronizaListProjects from './pages/Sincroniza/SincronizaListProjects';
import SincronizaCreateProject from './pages/Sincroniza/SincronizaCreateProject';
import SincronizaEditProject from './pages/Sincroniza/SincronizaEditProject';
import SincronizaConsultProjects from './pages/Sincroniza/SincronizaConsultProjects';
import SincronizaConsultResultProjects from './pages/Sincroniza/SincronizaConsultResultProjects';
import Contabil from './pages/NovoSistema/Contabil/Contabil';
import RelatoriosContabeis from './pages/NovoSistema/Contabil/RelatoriosContabeis';
import ObrigacoesAcessorias from './pages/NovoSistema/Contabil/ObrigacoesAcessorias';
import Controladoria from './pages/NovoSistema/Controladoria/Controladoria';
import OrcamentoAnual from './pages/NovoSistema/Controladoria/OrcamentoAnual';
import EstruturaOrcamentaria from './pages/NovoSistema/Controladoria/EstruturaOrcamentaria';
import GestaoFinanceira from './pages/NovoSistema/Controladoria/GestaoFinanceira';
import GestaoAlcadas from './pages/NovoSistema/Controladoria/GestaoAlcadas';
import Billing from './pages/NovoSistema/Controladoria/Billing';
import Dashboard from './pages/NovoSistema/Controladoria/Dashboard';
import Fiscal from './pages/NovoSistema/Fiscal/Fiscal';
import ApuracaoTributaria from './pages/NovoSistema/Fiscal/ApuracaoTributaria';
import ObrigacoesAcessoriasFiscal from './pages/NovoSistema/Fiscal/ObrigacoesAcessorias';
import FinanceiroHospitalar from './pages/NovoSistema/FinanceiroHospitalar/FinanceiroHospitalar';
import GestaoDePessoas from './pages/NovoSistema/GestaoDePessoas/GestaoDePessoas';
import Mandala from './pages/NovoSistema/Mandala/Mandala';
import BudgetActualForecast from './pages/NovoSistema/Controladoria/BudgetActualForecast';
import Page404 from './pages/Page404';
import SincronizaConsultBillingsMonth from './pages/Sincroniza/SincronizaConsultBillingsMonth';
import ClientsProjectsAndCompaniesReg from './pages/Sincroniza/ClientsProjectsAndCompanies/ClientsProjectsAndCompaniesReg';
import ClientsProjectsAndCompaniesEdit from './pages/Sincroniza/ClientsProjectsAndCompanies/ClientsProjectsAndCompaniesEdit';
import LinksSystemReg from './pages/LinksSystem/LinksSystemReg';
import ClientsLinksSystemEdit from './pages/LinksSystem/LinksSystemEdit';
import CND from './pages/NovoSistema/Fiscal/CND';

const GlobalStyle = createGlobalStyle`
  body {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: 'Ubuntu', sans-serif;
    background-color: ${({ theme }) => {
      return theme.colors.white;
    }};
  }
`;

const theme = db.theme;

export default function App() {
  return (
    <BrowserRouter>
      <ThemeProvider theme={theme}>
        <main>
          <GlobalStyle />
          <Switch>
            <Route path="/" component={HomePage} exact></Route>
            <Route path="/login" component={Login} exact></Route>
            <Route path="/email-confirmado" component={ConfirmedEmail} exact></Route>
            <Route path="/recuperar-senha" component={RecoverPassword} exact></Route>
            <Route path="/registro-empresa" component={CompanyReg} exact></Route>
            <Route path="/editar-empresa/:id" component={CompanyEdit} exact></Route>
            <Route path="/registro-pessoa" component={UserReg} exact></Route>
            <Route path="/pessoas-cadastradas" component={UserList} exact></Route>
            <Route path="/painel-usuario" component={UserEdit} exact></Route>
            <Route path="/editar-usuario/:id" component={UserEditAdmin} exact></Route>
            <Route path="/registro-links-sistema" component={LinksSystemReg} exact></Route>
            <Route path="/editar-links-sistema/:id" component={ClientsLinksSystemEdit} exact></Route>

            {/*------------------------------------ Sistema Sincroniza ------------------------------------*/}
            <Route path="/sincroniza-nfe" component={SincronizaListProjects} exact></Route>
            <Route path="/sincroniza-nfe/criar-faturamento" component={SincronizaCreateProject} exact></Route>
            <Route path="/sincroniza-nfe/editar-faturamento/:id" component={SincronizaEditProject} exact></Route>
            <Route path="/buscar/pessoas-cadastradas" component={CompanyUserList} exact></Route>
            <Route path="/sincroniza-nfe/consultar-faturamentos" component={SincronizaConsultProjects} exact></Route>
            <Route
              path="/sincroniza-nfe/consultar-faturamentos/:id"
              component={SincronizaConsultResultProjects}
              exact
            ></Route>
            <Route
              path="/sincroniza-nfe/consultar-todos-faturamentos"
              component={SincronizaConsultBillingsMonth}
              exact
            ></Route>
            <Route
              path="/sincroniza-nfe/registro-cliente-projeto-empresa"
              component={ClientsProjectsAndCompaniesReg}
              exact
            ></Route>
            <Route
              path="/sincroniza-nfe/editar-cliente-projeto-empresa/:id"
              component={ClientsProjectsAndCompaniesEdit}
              exact
            ></Route>

            {/*------------------------------------ Novo Sistema ------------------------------------*/}
            <Route path="/novo-sistema/contabil" component={Contabil} exact></Route>
            <Route path="/novo-sistema/contabil/relatorios-contabeis" component={RelatoriosContabeis} exact></Route>
            <Route path="/novo-sistema/contabil/obrigacoes-acessorias" component={ObrigacoesAcessorias} exact></Route>
            <Route path="/novo-sistema/fiscal" component={Fiscal} exact></Route>
            <Route
              path="/novo-sistema/fiscal/obrigacoes-acessorias"
              component={ObrigacoesAcessoriasFiscal}
              exact
            ></Route>
            <Route path="/novo-sistema/fiscal/apuracao-tributaria" component={ApuracaoTributaria} exact></Route>
            <Route path="/novo-sistema/fiscal/cnd" component={CND} exact></Route>
            <Route path="/novo-sistema/controladoria" component={Controladoria} exact></Route>
            <Route path="/novo-sistema/controladoria/orcamento-anual" component={OrcamentoAnual} exact></Route>
            <Route
              path="/novo-sistema/controladoria/estrutura-orcamentaria"
              component={EstruturaOrcamentaria}
              exact
            ></Route>
            <Route path="/novo-sistema/controladoria/gestao-financeira" component={GestaoFinanceira} exact></Route>
            <Route path="/novo-sistema/controladoria/gestao-alcadas" component={GestaoAlcadas} exact></Route>
            <Route path="/novo-sistema/controladoria/billing" component={Billing} exact></Route>
            <Route path="/novo-sistema/controladoria/dashboard" component={Dashboard} exact></Route>
            <Route
              path="/novo-sistema/controladoria/dashboard/budget-actual-forecast"
              component={BudgetActualForecast}
              exact
            ></Route>
            <Route path="/novo-sistema/financeiro-hospitalar" component={FinanceiroHospitalar} exact></Route>
            <Route path="/novo-sistema/gestao-de-pessoas" component={GestaoDePessoas} exact></Route>
            <Route path="/novo-sistema/mandala" component={Mandala} exact></Route>

            <Route path="*" component={Page404}></Route>
          </Switch>
        </main>
      </ThemeProvider>
    </BrowserRouter>
  );
}
